import styled from 'styled-components';

import { TooltipPopup } from '@reach/tooltip';

export const tipWidth = 16;
export const tipHeight = 8;

function getStrongBackgroundColor(props) {
  const { color = 'black' } = props;

  switch (color) {
    case 'black':
      return 'var(--coolGray-900)';
    case 'teal':
    case 'pink':
      return `var(--${color}-900)`;
    default:
      return `var(--${color}-600)`;
  }
}

function getFadedBackgroundColor(props) {
  const { color = 'black' } = props;

  switch (color) {
    case 'black':
      return 'var(--coolGray-200)';
    case 'orange':
    case 'pink':
      return `var(--${color}-50)`;
    default:
      return `var(--${color}-100)`;
  }
}

function getBackgroundColor(props) {
  return (props.faded ? getFadedBackgroundColor : getStrongBackgroundColor)(props);
}

function getColor(props) {
  if (props.faded) {
    return getStrongBackgroundColor(props);
  }

  return 'var(--white)';
}

export const Popup = styled(TooltipPopup)`
  max-width: 192px;
  position: absolute;
  padding: 8px;
  background: ${getBackgroundColor};
  border-radius: 4px;
  color: ${getColor};
  font-size: 14px;
  text-align: center;
`;

const transformAfterRotate = (tipWidth - tipWidth / Math.SQRT2) / 2;

export const Tip = styled.div`
  width: ${tipWidth / Math.SQRT2}px;
  height: ${tipWidth / Math.SQRT2}px;
  position: absolute;
  top: 0;
  left: 0;
  background: ${getBackgroundColor};
  border-radius: 2px 0 0 0;
  transform: translate(${transformAfterRotate}px, ${transformAfterRotate}px) rotate(45deg);
  clip-path: polygon(0 0, 0 100%, 100% 0, 0 0);
`;
